import PropTypes from 'prop-types';
// @mui
import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// auth recipes
import { authProviderButtonSx } from 'src/layouts/auth/portals';

// ----------------------------------------------------------------------
// "CONTINUE WITH MICROSOFT" — the one single-sign-on way in, on the intranet.
//
// The mark is Microsoft's own four squares in Microsoft's own colours, drawn
// inline (no dependency, no image request) and never recoloured: Microsoft's
// branding guidelines allow the logo beside the words on a light or a dark
// button and nothing else. The button around it is the system's (§17
// secondary, the auth height), so it sits in the card's column as one of its
// controls rather than as somebody else's widget pasted in.
// ----------------------------------------------------------------------

MicrosoftLogo.propTypes = { size: PropTypes.number };

export function MicrosoftLogo({ size = 18 }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 21 21"
      aria-hidden
      focusable="false"
      sx={{ width: size, height: size, display: 'block', flex: 'none' }}
    >
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </Box>
  );
}

MicrosoftButton.propTypes = {
  onClick: PropTypes.func,
  /** Leaving for Microsoft, or back and being signed in. */
  loading: PropTypes.bool,
  /** What the button says while `loading`. */
  loadingLabel: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string
};

export default function MicrosoftButton({
  onClick,
  loading = false,
  loadingLabel = 'Redirecting to Microsoft…',
  disabled = false,
  label = 'Continue with Microsoft'
}) {
  return (
    <LoadingButton
      fullWidth
      // never the form's submit: Enter in the password field signs in with
      // the password
      type="button"
      variant="outlined"
      disableRipple
      onClick={onClick}
      loading={loading}
      loadingPosition="start"
      startIcon={<MicrosoftLogo />}
      disabled={disabled}
      aria-busy={loading || undefined}
      sx={authProviderButtonSx}
    >
      <span className="notranslate" translate="no">
        {loading ? loadingLabel : label}
      </span>
    </LoadingButton>
  );
}
